import React from 'react'
import { Icon } from 'konsys-ui'
import ReactHtmlParser from 'react-html-parser'
import { theme } from '../../../../../../styles/_variables'
import {
  Label, TitleWrapper, DescriptionWrapper,
  Container,
} from './styled'

const Recommendation = ({ value }) => (
  <Container>
    <TitleWrapper>
      <Icon icon='far fa-question-circle' color={theme.color.tertiaryColor} />
      <Label>คำแนะนำ</Label>
    </TitleWrapper>
    <DescriptionWrapper>
      {value && ReactHtmlParser(value)}
    </DescriptionWrapper>
  </Container>
)

export default Recommendation



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/components/common/recommendation/index.jsx